module.exports = __webpack_public_path__ + "img/bg_01.7e06a97c.jpg";